(function(){
  if (window.LioiSmartSearch?.boot) { window.LioiSmartSearch.boot(); return; }
  const RECENT_KEY = "lioi-smart-search-recent";
  const analyticsTimers = new WeakMap();
  const analyticsLast = new WeakMap();
  const analyticsFlows = new WeakMap();
  const eventId = () => typeof crypto !== "undefined" && crypto.randomUUID ? crypto.randomUUID() : Date.now().toString(36) + Math.random().toString(36).slice(2);
  const previewAdapters = new Set();
  let activePopupTrigger = null;
  let popupKeyHandlerBound = false;
  const normalize = (value) => String(value || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]+/g, " ").trim();
  const splitTerms = (value) => normalize(value).split(/\s+/).filter(Boolean);
  const escapeHtml = (value) => String(value == null ? "" : value).replace(/[&<>"']/g, (char) => ({ "&":"&amp;", "<":"&lt;", ">":"&gt;", '"':"&quot;", "'":"&#039;" }[char]));
  const absoluteUrl = (url) => {
    const raw = String(url || "").trim();
    if (!raw) return "#";
    if (/^https?:\/\//i.test(raw)) return raw;
    return raw.startsWith("/") ? raw : "/" + raw;
  };

  function getRecentSearches() {
    try {
      const items = JSON.parse(localStorage.getItem(RECENT_KEY) || "[]");
      return Array.isArray(items) ? items.filter(Boolean).slice(0, 7) : [];
    } catch {
      return [];
    }
  }

  function saveRecentSearch(query) {
    const clean = String(query || "").trim();
    if (!clean) return;
    const items = [clean].concat(getRecentSearches().filter((item) => normalize(item) !== normalize(clean))).slice(0, 7);
    try {
      localStorage.setItem(RECENT_KEY, JSON.stringify(items));
    } catch {}
  }

  function sendAnalytics(root, payload) {
    if (root.dataset.preview === "true" || window.Shopify?.designMode) return;
    if (/[?&]preview_theme_id=/.test(window.location?.search || "")) return;
    if (document.querySelector?.("#PBarNextFrame, iframe[src*='/shopifycloud/preview-bar/']")) return;
    if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true) return;
    const url = String(root.dataset.analyticsUrl || document.querySelector?.("[data-lioi-smart-search]")?.dataset.analyticsUrl || "").trim();
    if (!url || !payload?.query) return;
    try {
      let flow = analyticsFlows.get(root);
      if (!flow || Date.now() - flow.at > 30000 || flow.finished && payload.type === "search") flow = { id: eventId(), at: Date.now() };
      flow.at = Date.now();
      if (["click", "submit", "view_all"].includes(payload.type)) {
        clearTimeout(analyticsTimers.get(root));
        flow.finished = true;
        try { sessionStorage.setItem("lioi-search-flow", JSON.stringify({ id: flow.id, query: normalize(payload.query), at: flow.at })); } catch {}
      }
      analyticsFlows.set(root, flow);
      const body = JSON.stringify(Object.assign({ id: eventId(), searchId: flow.id, source: root.dataset.analyticsSource || "storefront" }, payload));
      if (navigator.sendBeacon && navigator.sendBeacon(url, new Blob([body], { type: "text/plain;charset=UTF-8" }))) return;
      fetch(url, {
        method: "POST",
        headers: { "Content-Type": "text/plain;charset=UTF-8" },
        body,
        keepalive: true,
        credentials: "omit"
      }).catch(() => {});
    } catch {}
  }

  function scheduleSearchAnalytics(root, payload) {
    const key = normalize(payload?.query || "") + "|" + String(payload?.results || 0);
    clearTimeout(analyticsTimers.get(root));
    const flow = analyticsFlows.get(root);
    if (!normalize(payload?.query) || analyticsLast.get(root) === key && flow && !flow.finished && Date.now() - flow.at <= 30000) return;
    analyticsTimers.set(root, setTimeout(() => {
      analyticsLast.set(root, key);
      sendAnalytics(root, payload);
    }, 850));
  }

  const hasPhrase = (text, phrase) => Boolean(phrase) && (" " + normalize(text) + " ").includes(" " + normalize(phrase) + " ");
  const wordTokens = (value) => normalize(value).replace(/([a-z])(\d)/g, "$1 $2").replace(/(\d)([a-z])/g, "$1 $2").split(" ").filter(Boolean);
  const matchesWord = (word, candidate) => candidate === word || (!/\d/.test(word) && candidate.startsWith(word));
  const isModelWord = (words, position) => /\d/.test(words[position]) || /^\d/.test(words[position + 1] || "");
  const allWordsMatch = (text, phrase) => {
    const words = wordTokens(text);
    const queryWords = wordTokens(phrase);
    return queryWords.every((word, position) => words.some((candidate) => isModelWord(queryWords, position) ? candidate === word : matchesWord(word, candidate)));
  };
  const allProductWordsMatch = (item, phrase) => {
    const titleWords = wordTokens(item.title);
    const details = wordTokens([item.searchTerms, item.subtitle, item.brand].filter(Boolean).join(" "));
    const queryWords = wordTokens(phrase);
    return queryWords.every((word, position) => isModelWord(queryWords, position)
      ? titleWords.includes(word)
      : titleWords.some((candidate) => matchesWord(word, candidate)) || details.includes(word));
  };
  function expandQueries(query, rules) {
    const normalized = normalize(query);
    const variants = new Map([[normalized, ""]]);
    (rules.synonyms || []).forEach((group) => {
      const alternatives = [group.term].concat(group.aliases || []).map(normalize).filter(Boolean);
      alternatives.forEach((term) => {
        if (!hasPhrase(normalized, term)) return;
        alternatives.forEach((alias) => {
          const replacement = (" " + normalized + " ").replace(" " + term + " ", " " + alias + " ").trim();
          if (replacement !== normalized) variants.set(replacement, alias);
        });
      });
    });
    return Array.from(variants, ([phrase, alias]) => ({ phrase, alias }));
  }

  function targetMatches(item, target) {
    const value = normalize(target);
    if (!value) return false;
    return value === normalize(item.id) || value === normalize(item.productId) ||
      (item.skus || []).some((sku) => normalize(sku) === value) || hasPhrase(item.title, value);
  }

  function scoreItem(item, variant) {
    const phrase = variant.phrase;
    if (!phrase) return { score: 0, reason: "" };
    const title = normalize(item.title);
    const skus = item.skus || [];
    let score = 0;
    let reason = "";
    if (skus.some((sku) => normalize(sku) === phrase)) { score = 140; reason = "SKU exacto"; }
    else if (/^\d+$/.test(phrase) && skus.some((sku) => normalize(sku).startsWith(phrase))) { score = 125; reason = "Inicio del SKU"; }
    else if (hasPhrase(title, phrase)) { score = /\d/.test(phrase) ? 110 : 90; reason = "Modelo o nombre"; }
    else if (allWordsMatch(title, phrase)) { score = 65; reason = "Palabras del nombre"; }
    else if (item.type === "product" && allProductWordsMatch(item, phrase)) { score = 50; reason = "Nombre y descripción del producto"; }
    if (score && variant.alias) reason = "Sinónimo: " + variant.alias.toUpperCase() + " · " + reason;
    if (score && item.type === "product") score += 6;
    return { score, reason };
  }

  function findRedirect(query, rules) {
    const normalized = normalize(query);
    return (rules.redirects || []).find((redirect) => normalize(redirect.query) === normalized);
  }

  function findCollectionRule(query, rules) {
    const normalized = normalize(query);
    return (rules.collectionRules || []).find((rule) => normalize(rule.query) === normalized);
  }

  function getRecommendations(index, limit) {
    const byId = new Map((index.items || []).map((item) => [item.id, item]));
    const selected = (index.recommendations || []).map((id) => byId.get(id)).filter(Boolean);
    if (Array.isArray(index.recommendations)) return selected.slice(0, limit);
    return (index.items || []).filter((item) => item.type === "product").slice(0, limit);
  }

  function getSearchMatches(index, normalizedQuery) {
    const rules = index.rules || {};
    const directRule = (rules.direct || []).find((rule) => normalize(rule.query) === normalizedQuery);
    const variants = expandQueries(normalizedQuery, rules);
    const collectionRule = findCollectionRule(normalizedQuery, rules);
    const collection = normalize(collectionRule && collectionRule.collection);

    return (index.items || [])
      .map((item) => {
        if (directRule && !(directRule.matches || []).some((target) => targetMatches(item, target))) return { item, score: 0 };
        const best = variants.map((variant) => scoreItem(item, variant)).sort((a, b) => b.score - a.score)[0] || { score: 0, reason: "" };
        let { score, reason } = best;
        if (directRule) { score += 1000; reason = "Producto asignado a esta consulta"; }
        if (score > 0 && collection && item.type === "product" && normalize(item.subtitle) === collection) {
          score += 46;
          if (!directRule) reason = "Categoría preferida · " + reason;
        }
        if (score > 0) (rules.boosts || []).forEach((boost) => {
          if (normalize(boost.query) === normalizedQuery && (boost.matches || []).some((target) => targetMatches(item, target))) {
            score += 120;
            if (!directRule) reason = "Prioridad manual · " + reason;
          }
        });
        return { item, score, reason };
      })
      .filter((entry) => entry.score > 0)
      .sort((a, b) => b.score - a.score);
  }

  function getFullSearchUrl(query) {
    return "/search?type=product&q=" + encodeURIComponent(String(query || "").trim());
  }

  function goToFullSearch(root, query, resultCount) {
    const clean = String(query || "").trim();
    if (!clean) return;
    if (root.dataset.preview === "true") return;
    saveRecentSearch(clean);
    sendAnalytics(root, { type: "submit", query: clean, results: resultCount || 0 });
    window.location.href = getFullSearchUrl(clean);
  }

  function renderSearchCard(item, query, reason = "") {
    const image = item.image ? '<img src="' + escapeHtml(item.image) + '" alt="" loading="lazy">' : '<span class="lioi-search-fallback">' + escapeHtml((item.type || "?").slice(0, 1).toUpperCase()) + '</span>';
    const meta = [item.subtitle, item.skus && item.skus.length ? item.skus.slice(0, 3).join(" / ") : ""].filter(Boolean).join(" - ");
    const typeLabel = item.type === "catalog" ? "Catalogo" : item.type === "page" ? "Pagina" : "Producto";
    return '<a class="lioi-search-result" data-lioi-search-hit data-query="' + escapeHtml(query || item.title || "") + '" href="' + escapeHtml(absoluteUrl(item.url)) + '">' + image + '<span><em>' + escapeHtml(typeLabel) + '</em><strong>' + escapeHtml(item.title) + '</strong><small>' + escapeHtml(meta) + '</small>' + (reason ? '<small class="lioi-search-why">' + escapeHtml(reason) + '</small>' : '') + '</span></a>';
  }

  function renderFullSearchCard(item) {
    const image = item.image ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.title) + '" loading="lazy">' : '<span class="lioi-full-search-image-empty" aria-hidden="true"></span>';
    return '<a class="lioi-full-search-product" href="' + escapeHtml(absoluteUrl(item.url)) + '"><span class="lioi-full-search-product-image">' + image + '</span><span class="lioi-full-search-product-info"><strong>' + escapeHtml(item.title) + '</strong><small>' + escapeHtml(item.brand || 'Lioi') + '</small></span></a>';
  }

  function renderRecentSearches(root, index) {
    const recent = getRecentSearches();
    if (!recent.length) {
      return '<div class="lioi-search-empty compact">Todavia no hay busquedas recientes.</div>';
    }
    return recent.map((query) => '<button type="button" class="lioi-search-recent" data-lioi-recent-search="' + escapeHtml(query) + '">' + escapeHtml(query) + '</button>').join("");
  }

  function bindPanelActions(root, index) {
    root.querySelectorAll("[data-lioi-recent-search]").forEach((button) => {
      button.addEventListener("click", () => {
        const input = root.querySelector("[data-lioi-search-input]");
        const value = button.getAttribute("data-lioi-recent-search") || "";
        if (!input) return;
        input.value = value;
        renderResults(root, index, value);
        input.focus();
      });
    });

    root.querySelectorAll("[data-lioi-search-hit]").forEach((link) => {
      link.addEventListener("click", (event) => {
        if (root.dataset.preview === "true") { event.preventDefault(); return; }
        const query = link.getAttribute("data-query") || "";
        saveRecentSearch(query);
        sendAnalytics(root, {
          type: "click",
          query,
          targetTitle: link.querySelector("strong")?.textContent || "",
          targetUrl: link.getAttribute("href") || ""
        });
      });
    });

    root.querySelectorAll("[data-lioi-search-all]").forEach((link) => {
      link.addEventListener("click", (event) => {
        if (root.dataset.preview === "true") { event.preventDefault(); return; }
        const query = link.getAttribute("data-query") || "";
        saveRecentSearch(query);
        sendAnalytics(root, {
          type: "view_all",
          query,
          targetTitle: "Ver todos los resultados",
          targetUrl: link.getAttribute("href") || ""
        });
      });
    });
  }

  function renderResults(root, index, query) {
    const resultsNode = root.querySelector("[data-lioi-search-results]");
    if (!resultsNode) return;
    const normalizedQuery = normalize(query);
    const limit = Math.max(3, Math.min(Number(root.dataset.limit || 8), 12));
    const showRecent = root.dataset.showRecent !== "false";
    const panelClass = showRecent ? "lioi-search-panel" : "lioi-search-panel no-recent";
    const recentHtml = showRecent ? '<aside class="lioi-search-side"><span>Ultimos buscados</span>' + renderRecentSearches(root, index) + '</aside>' : "";
    root.classList.add("is-open");

    if (!normalizedQuery) {
      clearTimeout(analyticsTimers.get(root));
      analyticsFlows.delete(root);
      analyticsLast.delete(root);
      const recommended = getRecommendations(index, limit);
      resultsNode.innerHTML = '<div class="' + panelClass + '">' +
        recentHtml +
        '<section class="lioi-search-main"><div class="lioi-search-panel-head"><span>Recomendados</span><small>Seleccionados desde el panel Lioi</small></div>' +
        '<div class="lioi-search-recommend-grid">' + recommended.map((item) => renderSearchCard(item, item.title)).join("") + '</div></section>' +
        '</div>';
      bindPanelActions(root, index);
      return;
    }

    const redirect = findRedirect(query, index.rules || {});
    const allMatches = getSearchMatches(index, normalizedQuery);
    const matches = allMatches.slice(0, limit);
    const totalResults = allMatches.length + (redirect ? 1 : 0);
    scheduleSearchAnalytics(root, { type: "search", query, results: totalResults });

    const redirectHtml = redirect ? '<a class="lioi-search-result lioi-search-redirect" href="' + escapeHtml(absoluteUrl(redirect.url)) + '"><span>Ir directo</span><strong>' + escapeHtml(redirect.query) + '</strong></a>' : "";
    const matchesHtml = matches.map(({ item, reason }) => renderSearchCard(item, query, root.dataset.preview === "true" ? reason : "")).join("");
    const fullSearchHtml = totalResults > matches.length + (redirect ? 1 : 0)
      ? '<a class="lioi-search-view-all" href="' + escapeHtml(getFullSearchUrl(query)) + '" data-lioi-search-all data-query="' + escapeHtml(query) + '">Ver todos los resultados</a>'
      : "";

    resultsNode.innerHTML = '<div class="' + panelClass + '">' +
      recentHtml +
      '<section class="lioi-search-main"><div class="lioi-search-panel-head"><span>Resultados</span><small>' + escapeHtml(totalResults) + ' coincidencias</small></div>' +
      '<div class="lioi-search-results-list">' + (redirectHtml + matchesHtml + fullSearchHtml || '<div class="lioi-search-empty">No encontramos resultados. Prueba con otro nombre o SKU.</div>') + '</div></section>' +
      '</div>';
    bindPanelActions(root, index);
  }

  function init(root) {
    if (root.dataset.lioiInitialized === "true") return;
    const input = root.querySelector("[data-lioi-search-input]");
    const resultsNode = root.querySelector("[data-lioi-search-results]");
    if (!input || !resultsNode) return;
    root.dataset.lioiInitialized = "true";
    let index = null;
    let loading = null;
    let previewOverride = false;
    if (root.dataset.preview === "true") {
      previewAdapters.add((nextIndex) => {
        if (!nextIndex || !Array.isArray(nextIndex.items)) return;
        previewOverride = true;
        index = nextIndex;
        root.dataset.ready = "true";
        if (root.classList.contains("is-open")) renderResults(root, index, input.value);
      });
    }
    const loadIndex = () => {
      if (loading) return loading;
      resultsNode.innerHTML = '<div class="lioi-search-empty" role="status">Cargando productos...</div>';
      loading = (async () => {
        for (let attempt = 0; attempt < 2; attempt += 1) {
          try {
            const response = await fetch(root.dataset.indexUrl, { cache: "no-store" });
            if (!response.ok) throw new Error("HTTP " + response.status);
            const data = await response.json();
            if (!Array.isArray(data.items)) throw new Error("Indice incompleto");
            if (previewOverride) return;
            index = data;
            root.dataset.ready = "true";
            if (root.classList.contains("is-open")) renderResults(root, index, input.value);
            return;
          } catch (error) {
            if (attempt === 1) {
              console.error("Lioi Smart Search:", error);
              root.dataset.ready = "false";
              resultsNode.innerHTML = '<div class="lioi-search-empty" role="status">No se pudo cargar el buscador. <button type="button" class="lioi-search-retry" data-lioi-search-retry>Reintentar</button></div>';
            }
          }
        }
      })().finally(() => { loading = null; });
      return loading;
    };
    const showResults = () => {
      root.classList.add("is-open");
      if (index) renderResults(root, index, input.value);
      else void loadIndex();
    };
    input.addEventListener("input", showResults);
    input.addEventListener("focus", showResults);
    input.addEventListener("keydown", (event) => {
      if (event.key === "Escape") { root.classList.remove("is-open"); return; }
      if (event.key !== "Enter") return;
      event.preventDefault();
      if (!index) { void loadIndex(); return; }
      const query = input.value;
      const normalizedQuery = normalize(query);
      const resultCount = normalizedQuery ? getSearchMatches(index, normalizedQuery).filter((entry) => entry.item.type === "product").length : 0;
      goToFullSearch(root, query, resultCount);
    });
    root.addEventListener("click", (event) => {
      if (event.target.closest("[data-lioi-search-retry]")) void loadIndex();
    });
    document.addEventListener("click", (event) => {
      if (!root.contains(event.target)) root.classList.remove("is-open");
    });
    void loadIndex();
  }

  function initSearchPage(page) {
    if (page.dataset.lioiPageInitialized === "true") return;
    page.dataset.lioiPageInitialized = "true";
    const input = page.querySelector('[name="q"]');
    const results = page.querySelector("[data-lioi-page-results]");
    const fallback = page.querySelector("[data-lioi-page-fallback]");
    const status = page.querySelector("[data-lioi-page-status]");
    if (!input || !results || !status) return;
    const query = input.value.trim();
    if (!query) { status.textContent = "Escribe un producto, modelo o SKU para buscar."; return; }
    if (fallback) fallback.hidden = true;
    let matches = [];
    let currentPage = 1;
    const render = () => {
      const selected = matches;
      const perPage = 24;
      const pages = Math.max(1, Math.ceil(selected.length / perPage));
      currentPage = Math.min(currentPage, pages);
      const visible = selected.slice((currentPage - 1) * perPage, currentPage * perPage);
      status.textContent = selected.length + (selected.length === 1 ? " producto encontrado" : " productos encontrados");
      results.innerHTML = visible.length
        ? '<div class="lioi-full-search-grid">' + visible.map(({ item }) => renderFullSearchCard(item)).join("") + '</div>' +
          (pages > 1 ? '<nav class="lioi-full-search-pages" aria-label="Páginas de resultados"><button type="button" data-page-step="-1"' + (currentPage === 1 ? ' disabled' : '') + '>Anterior</button><span>Página ' + currentPage + ' de ' + pages + '</span><button type="button" data-page-step="1"' + (currentPage === pages ? ' disabled' : '') + '>Siguiente</button></nav>' : '')
        : '<p class="lioi-full-search-empty">No encontramos productos que coincidan con esa búsqueda. Prueba con otro nombre, modelo o SKU.</p>';
    };
    results.addEventListener("click", (event) => {
      const product = event.target.closest(".lioi-full-search-product");
      if (product) sendAnalytics(page, { type: "click", query, targetTitle: product.querySelector("strong")?.textContent || "" });
      const step = Number(event.target.closest("[data-page-step]")?.dataset.pageStep || 0);
      if (!step) return;
      currentPage += step;
      render();
      page.scrollIntoView({ behavior: "smooth", block: "start" });
    });
    status.textContent = "Cargando resultados…";
    fetch(page.dataset.indexUrl, { cache: "no-store" }).then((response) => {
      if (!response.ok) throw new Error("HTTP " + response.status);
      return response.json();
    }).then((index) => {
      if (!Array.isArray(index.items) || !index.items.some(item => item.type === "product")) throw new Error("Índice incompleto");
      matches = getSearchMatches(index, normalize(query)).filter(({ item }) => item.type === "product");
      page.dataset.analyticsSource = "search-page";
      try {
        const flow = JSON.parse(sessionStorage.getItem("lioi-search-flow") || "null");
        if (flow && flow.query === normalize(query) && Date.now() - flow.at < 60000) analyticsFlows.set(page, flow);
      } catch {}
      sendAnalytics(page, { type: "submit", query, results: matches.length });
      if (fallback) fallback.hidden = true;
      render();
    }).catch(() => {
      if (fallback) fallback.hidden = false;
      results.innerHTML = "";
      status.textContent = "No se pudo cargar el índice Lioi. Se muestran los resultados de respaldo de Shopify.";
    });
  }

  function closePopup() {
    const section = document.querySelector(".lioi-smart-search-section.is-popup-mode.is-visible");
    if (!section) return;
    section.classList.remove("is-visible");
    section.querySelector("[data-lioi-smart-search]")?.classList.remove("is-open");
    document.body.classList.remove("lioi-search-modal-open");
    activePopupTrigger?.setAttribute("aria-expanded", "false");
    activePopupTrigger?.focus();
    activePopupTrigger = null;
  }

  function bindPopupTriggers() {
    if (typeof document.querySelector !== "function") return;
    const section = document.querySelector(".lioi-smart-search-section.is-popup-mode");
    document.querySelectorAll("[data-lioi-search-open]").forEach((button) => {
      button.hidden = !section;
      if (!section || button.dataset.lioiPopupBound) return;
      button.dataset.lioiPopupBound = "true";
      button.addEventListener("click", (event) => {
        event.stopPropagation();
        const dialog = document.querySelector(".lioi-smart-search-section.is-popup-mode");
        if (!dialog) return;
        activePopupTrigger = button;
        button.setAttribute("aria-expanded", "true");
        dialog.classList.add("is-visible");
        document.body.classList.add("lioi-search-modal-open");
        dialog.querySelector("[data-lioi-search-input]")?.focus();
      });
    });
    if (section && !section.dataset.lioiPopupBound) {
      section.dataset.lioiPopupBound = "true";
      section.addEventListener("click", (event) => {
        if (event.target.closest("[data-lioi-search-close], [data-lioi-search-backdrop]")) closePopup();
      });
    }
    if (!popupKeyHandlerBound) {
      popupKeyHandlerBound = true;
      document.addEventListener("keydown", (event) => {
        const dialog = document.querySelector(".lioi-smart-search-section.is-popup-mode.is-visible");
        if (!dialog) return;
        if (event.key === "Escape") { event.preventDefault(); closePopup(); return; }
        if (event.key !== "Tab") return;
        const focusable = Array.from(dialog.querySelectorAll('button:not([disabled]), input:not([disabled]), a[href]'));
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      });
    }
  }

  function boot(){
    if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === "function") {
      window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], function () {});
    }
    document.querySelectorAll("[data-lioi-smart-search]").forEach(init);
    document.querySelectorAll("[data-lioi-search-page]").forEach(initSearchPage);
    bindPopupTriggers();
  }
  window.LioiSmartSearch = {
    boot,
    searchIndex(index, query) { return getSearchMatches(index, normalize(query)); },
    setPreviewIndex(index) { previewAdapters.forEach((apply) => apply(index)); }
  };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot, { once: true });
  else boot();
  document.addEventListener("shopify:section:load", (event) => {
    event.target.querySelectorAll("[data-lioi-smart-search]").forEach(init);
    event.target.querySelectorAll("[data-lioi-search-page]").forEach(initSearchPage);
    bindPopupTriggers();
  });
})();
